import React from "react";
import { DatasetTypesManager } from "../../components/DatasetTypes/DatasetTypesManager";

/**
 * Admin console: the dataset type registry.
 */
export const DatasetTypes = () => <DatasetTypesManager />;

export default DatasetTypes;
